import { useState } from "react"
import { Copy, Check } from "lucide-react"

const CopyButton = ({ text, label = "Copy" }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <button
      onClick={handleCopy}
      className="p-1 rounded-md bg-neutral-100 dark:bg-neutral-700 hover:bg-neutral-200 dark:hover:bg-neutral-600 transition-colors"
      aria-label={label}
    >
      {copied ? (
        <Check size={14} className="text-green-500" />
      ) : (
        <Copy size={14} className="text-neutral-500 dark:text-neutral-400" />
      )}
    </button>
  )
}

export default CopyButton 
